import React from "react";
import {
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    BankOutlined,
    CalendarOutlined,
    InfoCircleOutlined,
    SafetyCertificateOutlined
} from "@ant-design/icons";
import { Col, Row, Tag } from "antd";
import CommonCard from "../../../global/card";
import { formatDateTime } from "../../../../utils/functions";

const EnhancedChangeUserEmailDetail = ({
    userDetail,
    setShowDetail
}) => {
    if (!userDetail || userDetail.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center p-8 text-center h-full">
                <div className="bg-red-50 p-4 rounded-full mb-4">
                    <InfoCircleOutlined className="text-3xl text-red-500" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2">No User Found</h3>
                <p className="text-gray-500 max-w-xs">
                    We couldn't find any user associated with this email address. Please check the email and try again.
                </p>
            </div>
        );
    }
    const user = userDetail[0];

    return (
        <div className="p-6" style={{ backgroundColor: "#f5f7fa" }}>
            <CommonCard
                title={
                    <div className="flex items-center gap-2">
                        <UserOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                        <span style={{ fontSize: "16px", fontWeight: 600 }}>User Details</span>
                    </div>
                }
            >
                <Row gutter={[24, 16]}>
                    <Col span={24} className="border-b border-gray-200 py-4 text-center">
                        <div className="size-24 bg-primary/10 rounded-full flex items-center justify-center text-primary mx-auto mb-3">
                            <span className="text-3xl font-bold">{user?.name?.charAt(0).toUpperCase()}</span>
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 m-0">{user?.name}</h3>
                        <p className="text-gray-500">{user?.email}</p>
                    </Col>

                    {[
                        { label: "Full Name", value: user?.name, icon: <UserOutlined /> },
                        { label: "Phone", value: user?.phone, icon: <PhoneOutlined /> },
                        { label: "Email", value: user?.email, icon: <MailOutlined /> },
                        { label: "Company", value: user?.company, icon: <BankOutlined /> },
                        { label: "Active Plan", value: user?.PaymentPlanInfo?.[0]?.planName, icon: <SafetyCertificateOutlined />, isTag: true },
                        { label: "Joined On", value: formatDateTime(user?.createdAt), icon: <CalendarOutlined /> },
                    ].map((item) => (
                        <Col span={12} key={item.label}>
                            <div className="flex flex-col p-3 rounded-lg hover:bg-gray-50 transition-colors">
                                <span className="text-xs text-gray-500 flex items-center gap-2 mb-1">
                                    <span style={{ color: "var(--primary-color, #1890ff)" }}>
                                        {item.icon || <InfoCircleOutlined />}
                                    </span>
                                    {item.label}
                                </span>
                                {item.isTag ? (
                                    <Tag color="blue" className="m-0 px-3 py-1 font-medium w-fit">
                                        {item.value || "Free"}
                                    </Tag>
                                ) : (
                                    <span className="text-sm font-semibold text-gray-900 break-words">{item.value || "—"}</span>
                                )}
                            </div>
                        </Col>
                    ))}
                </Row>
            </CommonCard>
        </div>
    );
};

export default EnhancedChangeUserEmailDetail;
